import { LOCALE_ID, NgModule } from '@angular/core';
import localePt from '@angular/common/locales/pt';
import { NgxMaskDirective, NgxMaskPipe, provideEnvironmentNgxMask } from 'ngx-mask';
import { registerLocaleData } from '@angular/common';
import { RouteReuseStrategy } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppComponent } from './app.component';
import { AppLockComponent } from './components/app-lock/app-lock.component';
import { MessageModule } from './shared/message';
import { StorageModule } from './shared/storage';
import { SecurityModule } from './shared/security';
import { AppRoutingModule } from './app-routing.module';
import { AuthClientModule } from './client/auth-client';
import { StoreManagementModule } from './store/store-management.module';
import { PolicyModal } from './modals/policy/policy.page';

registerLocaleData(localePt);

@NgModule({ declarations: [AppComponent, AppLockComponent, PolicyModal],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        AuthClientModule,
        IonicModule.forRoot(),
        MessageModule.forRoot(),
        BrowserAnimationsModule,
        StorageModule.forRoot(),
        StorageModule.forRoot(),
        NgxMaskDirective,
        NgxMaskPipe,
        SecurityModule.forRoot(),
        StoreManagementModule.forRoot()], providers: [
        NgxMaskPipe,
        provideEnvironmentNgxMask({ showMaskTyped: true }),
        {
            provide: RouteReuseStrategy,
            useClass: IonicRouteStrategy,
        },
        {
            provide: LOCALE_ID,
            useValue: 'pt-BR',
        },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule {}
